import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasOverflow", "href", "onClick", "analyticsContext", "iconBefore", "iconAfter"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { usePlatformLeafEventHandler } from '@atlaskit/analytics-next/usePlatformLeafEventHandler';
import Button from '@atlaskit/button/standard-button';
import __noop from '@atlaskit/ds-lib/noop';
var analyticsAttributes = {
  componentName: 'breadcrumbsItem',
  packageName: "@atlaskit/breadcrumbs",
  packageVersion: "11.7.12"
};
var noop = __noop;
export default /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$hasOverflow = _ref.hasOverflow,
    hasOverflow = _ref$hasOverflow === void 0 ? true : _ref$hasOverflow,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#' : _ref$href,
    _ref$onClick = _ref.onClick,
    onClickProvided = _ref$onClick === void 0 ? noop : _ref$onClick,
    analyticsContext = _ref.analyticsContext,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClicked = usePlatformLeafEventHandler(_objectSpread({
    fn: onClickProvided,
    action: 'clicked',
    analyticsData: analyticsContext
  }, analyticsAttributes));
  return /*#__PURE__*/React.createElement(Button, _extends({
    appearance: "subtle-link",
    spacing: "none",
    iconAfter: hasOverflow ? undefined : iconAfter,
    iconBefore: hasOverflow ? undefined : iconBefore,
    onClick: handleClicked,
    ref: ref,
    href: href
  }, props));
});